import { connect } from "react-redux";
import { Dispatch } from "redux";
import { handleAuth0Callback } from "../../actions";
import { AuthAction } from "../../actionTypes";
import CallbackRoute from "../presenters/CallbackRoute";

function mapStateToProps(auth: any, ownProps: any) {
    return {
        auth: auth.auth,
        ownProps,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AuthAction>) {
    return {
        onAuth0Callback: () => handleAuth0Callback(dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CallbackRoute);
